import React from 'react';
import { useTranslation } from 'react-i18next';

const SkipToContent = () => {
  const { t } = useTranslation();

  return (
    <a
      href="#main-content"
      className="skip-to-content"
      style={{
        position: 'absolute',
        left: '-9999px',
        zIndex: 999,
        padding: '1em',
        backgroundColor: '#000',
        color: '#fff',
        textDecoration: 'none',
        ':focus': {
          left: '0'
        }
      }}
      onFocus={(e) => {
        e.target.style.left = '0';
      }}
      onBlur={(e) => {
        e.target.style.left = '-9999px';
      }}
    >
      {t('accessibility.skipToContent', 'Skip to main content')}
    </a>
  );
};

export default SkipToContent;
